var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/* tslint:disable:cyclomatic-complexity */
import { observable, observe, action, computed } from "mobx";
import { UIMessageModel, StakeButtonsStatusesModel } from "../../../models";
import { UIMessageStatus, BetStatus, ButtonModifiers, MessageModifiers, StakeButtonsModifiers } from "../../../enums";
import { createTransformer } from "mobx-utils";
export class YourbetMiniBetSlipData {
    constructor(provider, dict) {
        this.messages = createTransformer((purchaseId) => {
            let allMessages = [];
            let tax = this.getTax(purchaseId);
            if (this.shouldDisplayError()) {
                allMessages = allMessages.concat(this.formatedErrors());
            }
            this.betStatus === BetStatus.NewOffer && allMessages.push(this.formatedStakeChangeMessage(purchaseId));
            this.betStatus === BetStatus.Accepted && allMessages.push(this.formatedAcceptedMessage(purchaseId));
            let currentPurchase = this.purchases.find(x => x.id === purchaseId);
            if (currentPurchase && currentPurchase.shouldAcceptNewOdds) {
                allMessages.push(this.formatedOddsChangeMessage(purchaseId));
            }
            tax !== "" && allMessages.push(this.formatedTaxMessage(tax));
            if (this.isBetWaitingOrAccepted) {
                allMessages = allMessages.concat(this.getPurchaseMessages(purchaseId));
            }
            return allMessages;
        });
        this.provider = provider;
        this.errors = this.provider.errors;
        this.selections = this.provider.selections;
        this.purchases = this.provider.purchases;
        this.bets = this.provider.bets;
        this.dict = dict;
        this.disposeErrors = () => { };
        this.disposePurchases = () => { };
        this.disposeSelections = () => { };
        this.disposeBetStatus = () => { };
        this.disposeStakeButtonsStatus = () => { };
        this.disposePlaceBetButtonState = () => { };
        this.disposeBets = () => { };
        this.isPlaceBetButtonDisabled = true;
        this.betStatus = this.provider.betStatus;
        this.stakeButtonsStatus = new StakeButtonsStatusesModel({ minusEnabled: false, plusEnabled: true });
    }
    activate() {
        this.disposeErrors = observe(this.provider, "errors", x => {
            this.updateErrors(x.newValue);
        });
        this.disposePurchases = observe(this.provider, "purchases", x => {
            this.updatePurchases(x.newValue);
        });
        this.disposeSelections = observe(this.provider, "selections", x => {
            this.updateSelections(x.newValue);
        });
        this.disposeBetStatus = observe(this.provider, "betStatus", x => {
            this.updateBetStatus(x.newValue);
        });
        this.disposeStakeButtonsStatus = observe(this.provider, "stakeButtonsStatus", x => {
            this.updateStakeButtonsStatus(x.newValue);
        });
        this.disposePlaceBetButtonState = observe(this.provider, "isPlaceBetButtonEnabled", x => {
            this.setIsBetButtonDisabled(!x.newValue);
        });
        this.disposeBets = observe(this.provider, "bets", x => {
            this.updateBets(x.newValue);
        });
        this.provider.activate();
    }
    deactivate() {
        this.provider.deactivate();
        this.betStatus = BetStatus.Default;
        this.disposeBetStatus();
        this.disposeErrors();
        this.disposePurchases();
        this.disposeSelections();
        this.disposeStakeButtonsStatus();
        this.disposePlaceBetButtonState();
        this.disposeBets();
    }
    //Testing purposes - delete after finish
    get isWaiting() {
        return this.betStatus === BetStatus.Waiting;
    }
    //Testing purposes - delete after finish
    get isAccepted() {
        return this.betStatus === BetStatus.Accepted;
    }
    changeStake(stake, buttonAction) {
        return this.provider.changeStake(stake, buttonAction);
    }
    updateSelections(updatedSelections) {
        this.selections = updatedSelections;
    }
    setIsBetButtonDisabled(value) {
        this.isPlaceBetButtonDisabled = value;
        return this.isPlaceBetButtonDisabled;
    }
    updateErrors(updatedErrors) {
        this.errors = updatedErrors;
    }
    updatePurchases(updatedPurchases) {
        this.purchases = updatedPurchases;
    }
    updateBets(updatedBets) {
        this.bets = updatedBets;
    }
    updateStakeButtonsStatus(updatedStatus) {
        this.stakeButtonsStatus = updatedStatus;
    }
    updateNewOfferStatus(waitingBetId, isAccepted) {
        this.provider.updateNewOfferStatus(waitingBetId, isAccepted);
    }
    updateOddsChangeStatus(isAccepted) {
        this.provider.updateOddsChangeStatus(isAccepted);
    }
    getBtnRejected() {
        return {
            label: this.dict.Clear,
            handler: this.clearPurchases,
            modifier: ButtonModifiers.clear
        };
    }
    getBtnAccepted() {
        return {
            label: this.dict.Clear,
            handler: this.clearPurchases,
            modifier: ButtonModifiers.clear
        };
    }
    getBtnNewOffer() {
        let stake = this.purchases.length && this.purchases[0] && this.purchases[0].stake;
        let betId = this.bets.length && this.bets[0] && this.bets[0].id || "0";
        return {
            label: stake,
            handler: this.updateNewOfferStatus.bind(this, betId, false),
            modifier: ButtonModifiers.changedStake
        };
    }
    get leftComponentStake() {
        let stake = this.purchases.length && this.purchases[0] && this.purchases[0].stake || "0";
        let res = {
            handler: this.changeStake.bind(this),
            buttons: {
                left: {
                    modifier: StakeButtonsModifiers.Minus,
                    handler: this.changeStake.bind(this, stake, StakeButtonsModifiers.Minus),
                    disabled: !this.stakeButtonsStatus.minusEnabled
                },
                right: {
                    modifier: StakeButtonsModifiers.Plus,
                    handler: this.changeStake.bind(this, stake, StakeButtonsModifiers.Plus),
                    disabled: !this.stakeButtonsStatus.plusEnabled
                }
            }
        };
        return res;
    }
    get leftComponentButton() {
        let betStatusKey = BetStatus[this.betStatus];
        let res;
        (typeof this[`getBtn${betStatusKey}`] === "function") ?
            res = this[`getBtn${betStatusKey}`]() :
            res = "";
        return res;
    }
    get rightComponent() {
        let purchase = this.purchases.length && this.purchases[0];
        let bet = this.bets.length && this.bets[0];
        if (this.betStatus === BetStatus.Accepted) {
            return {
                label: this.dict.RetainSelections,
                handler: this.retainPurchases,
                modifier: ButtonModifiers.place,
                disabled: false
            };
        }
        else if (this.betStatus === BetStatus.NewOffer && bet) {
            return {
                label: this.dict.AcceptStake,
                handler: this.updateNewOfferStatus.bind(this, bet.id, true),
                modifier: ButtonModifiers.accepted,
                disabled: false
            };
        }
        else if (purchase && purchase.shouldAcceptNewOdds) {
            return {
                label: this.dict.AcceptOdds,
                handler: this.updateOddsChangeStatus.bind(this, true),
                modifier: ButtonModifiers.accepted,
                disabled: false
            };
        }
        else {
            let placeButtonLabel = this.isPlaceBetButtonDisabled && this.selections.findIndex(s => s.suspended === true) !== -1
                ? this.dict.Danger
                : this.dict.PlaceBets;
            return {
                label: placeButtonLabel,
                handler: this.placeBet.bind(this),
                modifier: this.isPlaceBetButtonDisabled ? ButtonModifiers.disabled : ButtonModifiers.place,
                disabled: this.isPlaceBetButtonDisabled
            };
        }
    }
    updateBetStatus(updatedBetStatus) {
        this.betStatus = updatedBetStatus;
    }
    updateBetStatusToRejected() {
        this.updateBetStatus(BetStatus.Rejected);
    }
    get selectionsCount() {
        return this.selections.length;
    }
    removeError(key, type) {
        if (this.errors[key] && this.errors[key][type]) {
            this.errors.remove(this.errors[key]);
        }
        return this.errors;
    }
    formatedErrors() {
        let allErrors = [];
        this.errors.forEach((error, index) => (Object.keys(error).forEach(x => {
            let formatedError = new UIMessageModel({
                id: `error-${x}`,
                label: error[x].join(" "),
                modifier: MessageModifiers.Change,
                type: UIMessageStatus.Error,
                handler: this.removeError.bind(this, index, x)
            });
            allErrors.push(formatedError);
        }, this)), this);
        return allErrors;
    }
    formatedAcceptedMessage(purchaseId) {
        return new UIMessageModel({
            id: purchaseId ? `accepted-${purchaseId}` : `accepted`,
            modifier: MessageModifiers.Accepted,
            label: this.dict.BetsAccepted,
            type: UIMessageStatus.Accepted
        });
    }
    formatedOddsChangeMessage(purchaseId) {
        return new UIMessageModel({
            id: purchaseId ? `oddsChanged-${purchaseId}` : `oddsChanged`,
            modifier: MessageModifiers.Change,
            label: this.dict.OddsChanged,
            type: UIMessageStatus.Default
        });
    }
    formatedStakeChangeMessage(purchaseId) {
        return new UIMessageModel({
            id: purchaseId ? `stakeChanged-${purchaseId}` : `stakeChanged`,
            modifier: MessageModifiers.Change,
            label: this.dict.StakeChanged,
            type: UIMessageStatus.Waiting
        });
    }
    formatedTaxMessage(taxText, purchaseId) {
        return new UIMessageModel({
            id: purchaseId ? `tax-${purchaseId}` : `tax`,
            modifier: MessageModifiers.Tax,
            label: taxText,
            type: UIMessageStatus.Tax
        });
    }
    formatedPurchaseMessage(text, purchaseId) {
        return new UIMessageModel({
            id: purchaseId ? `purchase-msg-${purchaseId}` : `purchase-msg`,
            modifier: MessageModifiers.Purchase,
            label: text,
            type: UIMessageStatus.Purchase
        });
    }
    shouldDisplayError() {
        return (this.betStatus === BetStatus.Rejected || this.betStatus === BetStatus.Default) && this.errors.length !== 0 && this.selections.length > 0;
    }
    getTax(purchaseId) {
        let currentPurchase = this.purchases.find(x => x.id === purchaseId);
        return currentPurchase && currentPurchase.tax || "";
    }
    getPurchaseMessages(purchaseId) {
        let currentMessages = [];
        let currentPurchase = this.purchases.find(x => x.id === purchaseId);
        currentPurchase && currentPurchase.messages && currentPurchase.messages.forEach((msg) => {
            msg !== "" && currentMessages.push(this.formatedPurchaseMessage(msg, purchaseId));
        }, this);
        return currentMessages;
    }
    placeBet() {
        let result = false;
        this.purchases.forEach(p => {
            if (p && p.stake) {
                result = this.provider.placeBet(p.stake, this.selections);
            }
        }, this);
        return result;
    }
    removeSelection(selectionId) {
        let result = false;
        let selection = this.selections.find(sel => sel.id === selectionId);
        if (selection) {
            result = this.provider.removeSelections([selection]);
        }
        return result;
    }
    retainPurchases() {
        let result = false;
        this.purchases.forEach(p => {
            if (p.id && p.viewKey) {
                result = this.provider.retainPurchase(p.id, p.viewKey);
            }
        }, this);
        return result;
    }
    clearPurchases() {
        let result = false;
        let purchases = this.purchases.filter(x => x.id !== "" && x.viewKey !== undefined);
        if (purchases.length > 0) {
            result = this.provider.clearAllPurchases(purchases);
        }
        return result;
    }
    get isBetWaitingOrAccepted() {
        return this.betStatus === BetStatus.Waiting || this.betStatus === BetStatus.Accepted;
    }
    get stakeValue() {
        return this.purchases.length && this.purchases[0].stake || "0";
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], YourbetMiniBetSlipData.prototype, "errors", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], YourbetMiniBetSlipData.prototype, "purchases", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], YourbetMiniBetSlipData.prototype, "bets", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], YourbetMiniBetSlipData.prototype, "selections", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], YourbetMiniBetSlipData.prototype, "betStatus", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], YourbetMiniBetSlipData.prototype, "stakeButtonsStatus", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], YourbetMiniBetSlipData.prototype, "isPlaceBetButtonDisabled", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "deactivate", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], YourbetMiniBetSlipData.prototype, "isWaiting", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], YourbetMiniBetSlipData.prototype, "isAccepted", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "changeStake", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "updateSelections", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "setIsBetButtonDisabled", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "updateErrors", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "updatePurchases", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "updateBets", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "updateStakeButtonsStatus", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], YourbetMiniBetSlipData.prototype, "leftComponentStake", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], YourbetMiniBetSlipData.prototype, "leftComponentButton", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], YourbetMiniBetSlipData.prototype, "rightComponent", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "updateBetStatus", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "updateBetStatusToRejected", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], YourbetMiniBetSlipData.prototype, "selectionsCount", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, String]),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "removeError", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "retainPurchases", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "clearPurchases", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], YourbetMiniBetSlipData.prototype, "isBetWaitingOrAccepted", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], YourbetMiniBetSlipData.prototype, "stakeValue", null);
/* tslint:enable:cyclomatic-complexity */ 
//# sourceMappingURL=YourbetMiniBetSlipData.js.map